// extracted by mini-css-extract-plugin
export default {"spaceContainer":"ESDCVirtualSpace_spaceContainer__I3mwL"};